import { render, staticRenderFns } from "./ItemGerenciarList.vue?vue&type=template&id=498ee0fc&scoped=true&"
import script from "./ItemGerenciarList.vue?vue&type=script&lang=js&"
export * from "./ItemGerenciarList.vue?vue&type=script&lang=js&"
import style0 from "./ItemGerenciarList.vue?vue&type=style&index=0&id=498ee0fc&prod&lang=scss&scoped=true&"
import style1 from "./ItemGerenciarList.vue?vue&type=style&index=1&id=498ee0fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ee0fc",
  null
  
)

export default component.exports